export default __webpack_public_path__ + "media/images/svg/icon_bg_blue-83f7a44be60fb9b9a88b35b77c18435a.svg";